import { combineReducers } from 'redux';
import automobilesReducer from './Automobiles/slice';
import homeOfficeReducer from './HomeOffice/slice';
import bookKeepingReducer from './BookKeeping/slice';
import compensationReducer from './Compensation/slice';
import balanceSheetReducer from './BalanceSheet/slice';
import profitandLossStatementReducer from './ProfitandLossStatement/slice';
import rentalActivityReducer from './RentalActivity/slice';
import specialDeductionsInformationReducer from './SpecialDeductionsInformation/slice';
import paycheckProtectionProgramPPPReducer from './PaycheckProtectionProgramPPP/slice';
import miscellaneousInformationReducer from './MiscellaneousInformation/slice';


export default combineReducers({
  automobiles : automobilesReducer,  
homeOffice : homeOfficeReducer,  
bookKeeping : bookKeepingReducer,  
compensation : compensationReducer,  
balanceSheet : balanceSheetReducer,  
profitandLossStatement : profitandLossStatementReducer,  
rentalActivity : rentalActivityReducer,  
specialDeductionsInformation : specialDeductionsInformationReducer,  
paycheckProtectionProgramPPP : paycheckProtectionProgramPPPReducer,  
miscellaneousInformation : miscellaneousInformationReducer,  

});
